import { render, staticRenderFns } from "./SifreDegistirForm.vue?vue&type=template&id=58103760&scoped=true"
import script from "./SifreDegistirForm.vue?vue&type=script&lang=ts"
export * from "./SifreDegistirForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58103760",
  null
  
)

export default component.exports